module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "timeline-container timeline"
  }, _vm._l((_vm.points), function(point) {
    return _c('div', {
      staticClass: "timeline-block",
      on: {
        "click": function($event) {
          _vm.changeCurrentTimePoint(point)
        }
      }
    }, [_c('div', {
      staticClass: "timeline-img",
      class: ['timeline-img', point.pointColor === undefined ? 'red' : point.pointColor]
    }, [(point.img) ? _c('img', {
      attrs: {
        "src": _vm.getImg(point.img),
        "alt": ""
      }
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "timeline-content"
    }, [_c('h2', {
      domProps: {
        "textContent": _vm._s(point.title)
      }
    }), _vm._v(" "), _c('p', {
      domProps: {
        "textContent": _vm._s(point.text)
      }
    }), _vm._v(" "), (point.linkUrl) ? _c('a', {
      staticClass: "read-more",
      attrs: {
        "href": point.linkUrl,
        "target": "_blank"
      },
      domProps: {
        "innerHTML": _vm._s(point.linkText != undefined ? point.linkText : 'Read more')
      }
    }) : _vm._e(), _vm._v(" "), (point.date) ? _c('span', {
      staticClass: "date",
      domProps: {
        "textContent": _vm._s(point.date)
      }
    }) : _vm._e()])])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-582d62b6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/timeLine.vue
// module id = 9
// module chunks = 0